export const roleInput = 'choose_role'
export const changeRoleInput = 'change_role'

export const roleValues = [
  'sub_admin',
  'family',
  'guest']
